import { Route, Routes } from 'react-router-dom';

import { Paths } from 'constants/index';

import {
  Sites,
  Home,
  Dashboard,
  Site,
  Tool,
  Tools,
  ToolPublicOverview,
  Workers,
  WorkerView,
  Lab,
  Loggers,
  Logger,
  LoggerPublicOverview,
  LoggerVerificationCode,
  LoggerNewWorkplace,
  Pumps,
  Pump,
  Retailer,
  Retailers,
  Client,
  Clients,
  Laboratory,
  Laboratories,
  Sampler,
  Samplers,
  Users,
  User,
  Settings,
  Project,
  Profile,
  NotFound,
  Rentals,
  ActiveSamples
} from 'pages';

import Login from 'pages/Login/Login';
import Organization from 'pages/MyOrganization';
import { Layout } from 'containers';
import Scan from 'pages/Scan';
import Forbidden from 'pages/Forbidden/Forbidden';
import Private from './Private';
import ToolOverviewShell from './ToolOverviewShell';
import PublicLayout from 'containers/PublicLayout/PublicLayout';

const Router = () => {
  return (
    <Routes>
      <Route element={<Private><Layout /></Private>}>
        <Route index element={<Home />} />
        <Route path={Paths.DASHBOARD} element={<Dashboard />} />

        <Route path={Paths.SITES_ACTIVE} element={<Sites />} />
        <Route path={Paths.SITES_CLOSED} element={<Sites />} />
        <Route path={Paths.SITES_VIEW} element={<Site />} />
        <Route path={Paths.PROJECTS_VIEW} element={<Project />} />
        <Route path={Paths.SCAN} element={<Scan />} />

        <Route path={Paths.TOOLS_ACTIVE} element={<Tools />} />
        <Route path={Paths.TOOLS_INACTIVE} element={<Tools />} />
        <Route path={Paths.TOOLS_VIEW} element={<Tool />} />

        <Route path={Paths.WORKERS_ACTIVE} element={<Workers />} />
        <Route path={Paths.WORKERS_INACTIVE} element={<Workers />} />
        <Route path={Paths.WORKERS_VIEW} element={<WorkerView />} />

        <Route path={Paths.LABORATORY} element={<Lab />} />

        <Route path={Paths.ADMIN_LOGGERS} element={<Loggers />} />
        <Route path={Paths.ADMIN_LOGGERS_VIEW} element={<Logger />} />

        <Route path={Paths.ADMIN_PUMPS} element={<Pumps />} />
        <Route path={Paths.ADMIN_PUMPS_VIEW} element={<Pump />} />

        <Route path={Paths.ADMIN_RETAILERS} element={<Retailers />} />
        <Route path={Paths.ADMIN_RETAILERS_VIEW} element={<Retailer />} />

        <Route path={Paths.ADMIN_CLIENTS} element={<Clients />} />
        <Route path={Paths.ADMIN_CLIENTS_VIEW} element={<Client />} />

        <Route path={Paths.ADMIN_SAMPLERS} element={<Samplers />} />
        <Route path={Paths.ADMIN_SAMPLERS_VIEW} element={<Sampler />} />

        <Route path={Paths.ADMIN_LABORATORIES} element={<Laboratories />} />
        <Route path={Paths.ADMIN_LABORATORIES_VIEW} element={<Laboratory />} />

        <Route path={Paths.ADMIN_USERS} element={<Users />} />
        <Route path={Paths.ADMIN_USERS_VIEW} element={<User />} />

        <Route path={Paths.ADMIN_SETTINGS} element={<Settings />} />
        <Route path={Paths.MY_ORGANIZATION} element={<Organization />} />

        <Route path={Paths.MY_PROFILE} element={<Profile />} />

        <Route path={Paths.RENTALS} element={<Rentals />} />

        <Route path={Paths.ACTIVE_SAMPLES} element={<ActiveSamples />} />

        <Route path={Paths.NOT_FOUND} element={<NotFound replace />} />
        <Route path={'*'} element={<NotFound replace />} />
      </Route>

      <Route element={<ToolOverviewShell />}>
        <Route path={Paths.TOOLS_OVERVIEW} element={<ToolPublicOverview />} />
      </Route>

      {/* Logger flow behind the QR code on a v3 logger: the public shell directly (not the tools' shell
          that swaps in the app layout for logged-in users), so it looks the same logged in or not. */}
      <Route element={<PublicLayout />}>
        <Route path={Paths.LOGGERS_OVERVIEW} element={<LoggerPublicOverview />} />
        <Route path={Paths.LOGGERS_OVERVIEW_WORKPLACE} element={<LoggerNewWorkplace />} />
      </Route>
      <Route path={Paths.LOGGERS_OVERVIEW_CODE} element={<LoggerVerificationCode />} />

      <Route path={Paths.LOGIN} element={<Login />} />
      <Route path={Paths.FORBIDDEN} element={<Forbidden replace />} />
    </Routes>
  );
};

export default Router;
